import moment from 'moment';

function formatDate(dates) {
  return dates === '' ? '-' : moment(dates).format('DD-MM-YYYY hh:mm:ss');
}

function getCurrentYear() {
  return moment().year();
}

function formatBytes(size) {
  const units = ['B', 'KB', 'MB', 'GB'];
  let index = 0;

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  return `${size.toFixed(2)} ${units[index]}`;
}

function showSuccessNotification(VueInstance, message, autoHideDelay = 5000) {
  VueInstance.$bvToast.toast(message, {
    title: 'Success',
    variant: 'success',
    solid: true,
    autoHideDelay: autoHideDelay,
    headerClass: 'custom-toast-header-success',
    bodyClass: 'custom-toast-body-success',
  });
}

function showErrorNotification(VueInstance, message, title) {
  const h = VueInstance.$createElement;

  const errorMessages = Object.keys(message).map((field) => {
    const asterisk = h('span', { style: { color: 'red', marginRight: '4px' } }, ['*']);

    return h('div', {}, [asterisk, message[field]]);
  });

  const vNodesMsg = h('div', {}, errorMessages);

  VueInstance.$bvToast.toast([vNodesMsg], {
    title: title,
    solid: true,
    noAutoHide: true,
    headerClass: 'custom-toast-header-error',
    bodyClass: 'custom-toast-body-error',
  });
}

function titleCase(str) {
  return str.replace(/^_*(.)|_+(.)/g, (str, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
}

function truncateString(str, maxLength) {
  if (str && str.length > maxLength) {
    return str.slice(0, maxLength) + '...';
  }
  return str;
}

function countCharacters(message) {
  let matched = message.match(/[\n\|\^\€\{\}\[\]\~]/g);
  return message.length + (matched ? matched.length : 0);
}

function countSegments(message, brand = '') {
  let count = 1;
  const length = countCharacters(message) + countCharacters(brand);

  if (length > 156) {
    count = Math.ceil((length) / 153);
  }

  return count;
}

function formatCurrency(value, currency = 'MYR') {
  if (!value) return '0.00';
  return new Intl.NumberFormat('en-MY', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
  }).format(value);
}

function formatTIN(tin) {
  if (!tin) return '';
  return tin.toString().replace(/[^A-Z0-9]/gi, '').toUpperCase();
}

function formatPhoneNumber(number) {
  if (!number) return '';
  const cleaned = number.toString().replace(/\D/g, '');
  if (cleaned.length >= 10) {
      if (cleaned.startsWith('60')) {
          return cleaned.replace(/^60(\d{2})(\d{3,4})(\d{4})$/, '+60-$1-$2-$3');
      }
      return cleaned.replace(/^(\d{2})(\d{3,4})(\d{4})$/, '+60-$1-$2-$3');
  }
  return number;
}

function formatBRN(brn) {
  if (!brn) return '';
  return brn.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export {
  formatDate,
  getCurrentYear,
  formatBytes,
  showSuccessNotification,
  showErrorNotification,
  titleCase,
  truncateString,
  countCharacters,
  countSegments,
  formatCurrency,
  formatTIN,
  formatPhoneNumber,
  formatBRN
};
